import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root',
})
export class LabelService {
  private labels: any = {
    actions: 'Azioni',
    active: 'Attivo',
    active_principle: 'Principio Attivo',
    active_principles: 'Principi Attivi',
    additional_expenses: 'Spese Accessorie',
    address: 'Indirizzo',
    age: 'Età',
    amount: 'Importo',
    app_name: 'Psicogenius',
    are_you_sure_you_want_to_delete_this_appointment:
      'Sei sicuro di voler eliminare questo appuntamento?',
    bank_name: 'Nome Banca',
    bank_name_2: 'Seconda Banca',
    birth: 'Nascita',
    calendar: 'Calendario',
    cancel: 'Annulla',
    categories: 'Categorie',
    category: 'Categoria',
    certified_email: 'Pec',
    city: 'Città',
    clinical_history: 'Storia Clinica',
    client: 'Cliente',
    clients: 'Clienti',
    client_is_payer: 'Usa i dati del paziente per la fatturazione',
    close: 'Chiudi',
    code: 'Codice',
    codeAndDescription: 'Codice e Descrizione',
    codex: 'Codice',
    codex_and_description: 'Codice e descrizione',
    codice_fiscale: 'Codice Fiscale',
    fiscal_code: 'Codice Fiscale',
    company_name: 'Ragione Sociale',
    confirm: 'Conferma',
    country: 'Paese',
    country_of_birth: 'Paese di Nascita',
    contact_us: 'Contattaci',
    date: 'Data',
    date_document: 'Data Documento',
    date_of_birth: 'Data di Nascita',
    date_of_issue: 'Data Emissione',
    date_sent: 'Data Invio',
    delete: 'Elimina',
    denomination: 'Denominazione',
    description: 'Descrizione',
    diagnosis: 'Diagnosi',
    diagnosis_table: 'Tabella Diagnosi',
    discount_percentage: 'Sconto %',
    do_you_already_want_to_book_the_first_interview:
      'Vuoi già prenotare il primo appuntamento?',
    documents: 'Documenti',
    documents_table: 'Tabella Documenti',
    duplicate: 'Duplica',
    edit_appointment: 'Modifica Appuntamento',
    edit_pharmacotherapy: 'Modifica Farmacoterapia',
    email: 'Email',
    end_date: 'Data fine',
    end_day: 'Giorno fine',
    end_month: 'Mese fine',
    end_time: 'Ora fine',
    end_year: 'Anno fine',
    expiration_date: 'Data Scadenza',
    extract_topic: 'Estrai Topic',
    familiar: 'Familiare',
    family: 'Famiglia',
    faq: 'Faq',
    first_name: 'Nome',
    frequent_questions: 'Domande Frequenti',
    fiscal_address: 'Indirizzo',
    fiscal_address_same_as_residence:
      'Indirizzo fiscale e di residenza coincidono?',
    fiscal_city: 'Città',
    fiscal_province: 'Provincia',
    fiscal_street_number: 'Numero Civico',
    fiscal_zip_code: 'CAP',
    gender: 'Sesso (M o F)',
    generate_transcription: 'Genera Trascrizione',
    generality: 'Generalità',
    hobbies: 'Hobbies',
    hospitalizations_and_surgical_operations:
      'Ospedalizzazioni e Operazioni Chirurgiche',
    iban: 'Iban',
    iban_2: 'Secondo Iban',
    interviews: 'Appuntamenti',
    invoices: 'Fatture',
    invoices_in_draft: 'Fatture in Draft',
    invoices_received: 'Fatture Ricevute',
    invoices_sent: 'Fatture Emesse',
    last_modified_date: 'Data Ultima Modifica',
    last_name: 'Cognome',
    life_line: 'Linea di Vita',
    line_number: 'Numero Linea',
    logout: 'Logout',
    marital_status: 'Stato Civile',
    medical_history: 'Anamnesi',
    mobile: 'Numero di Telefono',
    modules: 'Moduli',
    name: 'Nome',
    nature: 'Natura',
    new: 'Nuovo',
    new_diagnosis: 'Nuova Diagnosi',
    new_familiar: 'Nuovo Familiare',
    new_interview: 'Nuovo Appuntamento',
    new_patient: 'Nuovo Paziente',
    new_pharmacotherapy: 'Nuova Farmacoterapia',
    new_significant_event: 'Nuovo Evento Significativo',
    number: 'Numero',
    number_of_children: 'N° Figli',
    note: 'Note',
    notes: 'Appunti',
    occupation: 'Occupazione',
    other: 'Altro',
    partita_iva: 'Partita IVA',
    patient: 'Paziente',
    pathologies: 'Patologie',
    patients: 'Pazienti',
    payment_day: 'Data Pagamento',
    personal: 'Personale',
    personal_area: 'Area Personale',
    pharmacological_anamnesis: 'Anamnesi Farmacologica',
    pharmacoterapy: 'Farmacoterapia', // todo: fix typo
    physical_person: 'Persona Fisica',
    place_of_birth: 'Città di Nascita',
    postal_code: 'CAP',
    previous_clinical_paths: 'Percorsi Clinici Precedenti',
    price: 'Prezzo',
    province: 'Provincia',
    province_of_birth: 'Provincia di Nascita (es: MI)',
    quantity: 'Quantità',
    recipient_code: 'Codice Destinatario',
    residence_address: 'Indirizzo',
    residence_city: 'Città',
    residence_province: 'Provincia',
    residence_street_number: 'Numero Civico',
    residence_zip_code: 'CAP',
    registry: 'Anagrafica',
    regulatory_reference: 'Riferimento Normativo',
    relation: 'Relazione',
    reminder: 'Promemoria',
    residence: 'Residenza',
    rounding: 'Arrotondamento',
    sc_mg_amount: 'SC/MG: Importo',
    sc_mg_percentage: 'SC/MG: Percentuale',
    sc_mg_type: 'SC/MG: Tipo',
    semantic_analysis: 'Analisi Semantica',
    send: 'Invia',
    sexual_orientation: 'Orientamento Sessuale',
    significant_events: 'Eventi Significativi',
    social_relationships: 'Relazioni Sociali',
    sports: 'Sport',
    start_date: 'Data inizio',
    start_day: 'Giorno inizio',
    start_month: 'Mese inizio',
    start_time: 'Ora inizio',
    start_year: 'Anno inizio',
    status: 'Stato',
    street_number: 'Numero Civico',
    sts_password: 'Password STS',
    sts_pin: 'PIN STS',
    sts_username: 'Username STS',
    substances: 'Sostanze',
    supports: 'Supporti',
    tax_code: 'Codice Fiscale',
    tax_document_number: 'Numero Documento Fiscale',
    therapeutic_relationship: 'Relazione Terapeutica',
    tax: 'Imposta',
    taxable: 'Imponibile',
    title: 'Titolo',
    transcription: 'Trascrizione',
    topic: 'Topic',
    total: 'Totale',
    total_price: 'Prezzo Totale',
    type: 'Tipo',
    unique_code: 'Codice Univoco',
    unit_measure: 'Unità Misura',
    unit_of_measure: 'UM',
    upload_document: 'Carica Documento',
    upload_registration: 'Carica Registrazione',
    values: 'Valori',
    vat: 'IVA',
    vat_due_date: 'Esigibilità IVA',
    vat_number: 'Partita IVA',
    vat_rate: 'Aliquota IVA',
    year: 'Anno',
    years: 'Anni',
    years_of_education: 'Anni di Educazione',
  };

  constructor() {}

  getLabel(key: string): string {
    return this.labels[key] || key; // returns the key if the value is not found
  }
}
